<template>
	<div class="pending_wrap">
    <step-status :step="step" v-if="step" class="mt55"></step-status>

		<h1>Pending result</h1>
		<!-- interview -->
		<div v-show='inp1' class="letter">
			<p>Dear {{full_name}},</p>
			<p>Thank you for requesting an interview with HAWO. <br>Currently there are no available times. You may check our interview availability again tomorrow, or reach out to us at
				<a :href="need_mail">{{e_mail}}</a>.</p>
			<p></p>
			<p>Best,<br/>The HAWO Recruitment Team</p>
		</div>

		<div v-show='inp2' class="letter">
			<p>Dear {{full_name}},</p>
			<p>Please make sure to check your email or Skype for the next step/s in the process. Your recruiter will be reaching out to you via those channels.</p>
			<p>You may also add the HAWO Recruitment Skype: live:.cid.9d7dbebba05d49b9 for faster coordination.</p>
			<p>Best,<br/>The HAWO Recruitment Team</p>
		</div>

		<div class="download">
			<ul class="clearfix">
				<li>
					<ac></ac>
				</li>
			</ul>
		</div>
	</div>
</template>
<script>
import ac from '@common/ac.vue'
export default {
  props: {},
  components: {
    ac
  },
  data() {
    return {
      full_name: '',
      inp1: false,
			inp2: false,
      e_mail: 'teach@51talk.com',
      need_mail: '',
      arrImg: {
        img_url: false,
        img_url2: false,
        img_url4: false,
      },
      isMac: false,
      isWindows: false,
      step: null
    }
  },
  beforeRouteEnter: function(to, from, next) {
    next(vm => {
      if (from.name == 'book_interview') {
        vm.inp1 = true
        vm.$http.get('/interview/getTutorProfile').then(d => {
          if ((d.data.code == '75000')) {
            vm.full_name = d.data.res.tutor.full_name
            vm.step = 2
          }
        })
      } else if (from.name == 'book_tpg') {
        vm.inp2 = true
        vm.$http.get('/tpg/getTutorInfo').then(d => {
          if ((d.data.code == '75000')) {
            vm.full_name = d.data.res.tutor.full_name
            vm.step = 4
          }
        })
      } else if (from.name == 'book_demo') {
        vm.inp2 = true
        vm.$http.get('/demo/getTutorInfo').then(d => {
          if ((d.data.code == '75000')) {
            vm.full_name = d.data.res.tutor.full_name
            vm.step = 4
          }
        })
			}
			
      vm.need_mail = 'mailto:' + vm.e_mail
    })
  }
}
</script>
<style lang='less' scoped>
.pending_wrap {
  height: 752px;
  width: 1000px;
  margin: 0 auto;
  & > h1 {
    margin-top: 55px;
    font-size: 24px;
    font-weight: bolf;
    color: #ffb400;
  }
  div.letter {
    box-sizing: border-box;
    height: 384px;
    background: #f7f7f7;
    border-radius: 10px;
    margin-top: 30px;
    padding: 40px 30px;
    p {
      padding-bottom: 24px;
      line-height: 20px;
      color: #1e1e1e;
      a {
        color: #1e1e1e;
      }
    }
  }
  .download {
    position: fixed;
    top: 166px;
    right: 80px;
    & > ul {
      width: 75px;
      li {
        float: left;
        margin-top: 6px;
        background-color: #fff;
        border-radius: 5px;
        a {
          display: inline-block;
          box-sizing: border-box;
          vertical-align: middle;
          width: 75px;
          height: 75px;
          text-align: center;
          padding-top: 52px;
          background: url('~@img/donwload_icons.png') no-repeat
            center 10px;
          box-shadow: 0 0 2px 2px #ecebec;
          border-radius: 5px;
          &.mypage_icon {
            background-image: url('~@img/mypage_icons.png');
          }
          &:hover {
            border: 1px solid #fcc800;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// pending.vue?cd90efb2